@for (column of headerRowDefUIDirective.columns(); track column) {
  @if (column | getHeaderCell; as headerCell) {
    <ng-container
      [ngTemplateOutlet]="headerCell.templateRef"
      [ngTemplateOutletContext]="{ $implicit: column | getOriginalColumnName }"
    />
  } @else if (headerRowDefUIDirective.rowName()) {
    <!-- A named row (e.g. the filter row) may skip columns: keep their grid track so the other
         cells stay under their columns -->
    <div></div>
  }
}
